import { makeStyles } from '@material-ui/core'

const useCookiesSectionStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  categoryCard: {
    border: '1px solid',
    borderColor: theme.palette.divider,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    padding: theme.spacing(2),
    gap: 16,
  },
  categoryHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  categoryTitle: {
    fontWeight: 400,
    fontSize: 16,
  },
  alwaysActive: {
    fontWeight: 400,
    fontSize: 12,
  },
  detailsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}))

export default useCookiesSectionStyles
